import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  @Input() params: any;
  @Input() type: any;

  constructor(private modal: NzModalRef<any>) { }

  ngOnInit(): void {    
    if(this.params){
      this.type = this.params.type ? this.params.type : "confirm";
    }else{
      this.type = "confirm";
    }
  }
  
  confirm(): void{
    this.modal.close(true);
  }
  cancel(): void{
    this.modal.close(false);
  }

  closeDialog(data:any){
    this.modal.close(data);
  }


}
